const extractFormikValue = (name: string, formikValues) => {
  const nameSplit = name.split(".");
  if (nameSplit.length === 1) return formikValues[name];
  if (!nameSplit[1]) return formikValues[name];
  return formikValues[nameSplit[0]][nameSplit[1]];
};

export default extractFormikValue;
